import React from "react";

/**
 * Shown above the alert list whenever the applied group is a slice of the
 * account. The picker can be collapsed; this line is what still names the scope.
 */
export const AlertsScopeLine = ({
  pathLabel,
  siteLabel,
  otherLabel,
  onViewAll,
}: {
  pathLabel: string;
  siteLabel: string | null;
  otherLabel: string | null;
  onViewAll: () => void;
}) => (
  <p
    role="status"
    className="font-mulish px-4 pb-2 text-[14px] text-actuate-blue"
  >
    Showing <span className="font-bold">{pathLabel}</span>
    {siteLabel ? ` — ${siteLabel}` : ""}
    {otherLabel ? (
      <>
        {". "}
        <span className="font-bold">{otherLabel}</span>
        {" in your account in this window"}
      </>
    ) : null}
    {" · "}
    <button
      type="button"
      onClick={onViewAll}
      className="font-mulish text-actuate-orange underline"
    >
      View all
    </button>
  </p>
);
